import { mergeProps, splitProps } from "solid-js";
import classNames from "./classnames";
import { useBootstrapPrefix } from "./ThemeProvider";
import AbstractModalHeader from "./AbstractModalHeader";
const defaultProps = {
    closeLabel: "Close",
    closeButton: false,
};
const ModalHeader = (p) => {
    const [local, props] = splitProps(mergeProps(defaultProps, p), ["bsPrefix", "class"]);
    const bsPrefix = useBootstrapPrefix(local.bsPrefix, "modal-header");
    return <AbstractModalHeader {...props} class={classNames(local.class, bsPrefix)}/>;
};
export default ModalHeader;
